enum ChangeLogRoutes {
  List = '/change-log',
  Edit = '/change-log/:id',
}

export default ChangeLogRoutes
